"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
function arrayToObject(objects) {
    if (!objects) {
        return {};
    }
    return lodash_1.fromPairs(objects.map(item => {
        return [item.id, item];
    }));
}
function normalizeZaps(zaps) {
    return lodash_1.fromPairs(zaps.objects.map(zap => {
        const nodes = arrayToObject(zap.nodes.map(node => lodash_1.omit(Object.assign(Object.assign({}, node), { authentication_id: node.auth_id }), ['auth_id'])));
        return [
            zap.id,
            Object.assign(Object.assign({}, zap), { authentication_id: zap.auth_id, nodes, nodeIds: [] }),
        ];
    }));
}
exports.default = normalizeZaps;
